import DatedCard from "./DatedCard";

export default DatedCard;
